var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"hamburger",class:{'is-active':_vm.isActive},on:{"click":_vm.toggleClick}},[_c('span',{staticClass:"hamburger__line"}),_c('span',{staticClass:"hamburger__line"}),_c('span',{staticClass:"hamburger__line"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }